const RoleNames = {
  ADMIN: 'admin',
  CLASSIFIER: 'classifier',
  USER: 'user',
  CLASSIFIER_WITH_CATEGORY_PERMISSIONS: 'Classifier with Category Permissions',
  OPERATIONS: 'Operations',
  UPB_VIEWER: 'upb viewer',
  UPB_VIEWER_ADMIN: 'upb viewer admin',
  UPB_SALES_VIEWER: 'upb sales viewer',
  SYNCS: 'syncs',
  BRAND_HARVESTING: 'Brand Harvesting',
  SUPER_ADMIN: 'Super Admin',
};

export const HomeUrls = [
  { label: '/product-lists', value: RoleNames.ADMIN },
  { label: '/global-products/classify', value: RoleNames.CLASSIFIER },
  { label: '/upb-viewer', value: RoleNames.USER },
  { label: '/global-products/classify', value: RoleNames.CLASSIFIER_WITH_CATEGORY_PERMISSIONS },
  { label: '/product-lists', value: RoleNames.OPERATIONS },
  { label: '/upb-viewer', value: RoleNames.UPB_VIEWER },
  { label: '/upb-viewer', value: RoleNames.SYNCS },
  { label: '/enrich-products/brand-harvest', value: RoleNames.BRAND_HARVESTING },
  { label: '/product-lists', value: RoleNames.SUPER_ADMIN },
];

export default RoleNames;
